<style scoped>

</style>
<template>
    <div>
    </div>
</template>
<script>
    export default {
        created(){
            eventHub.$on('error', (e) => {
                this.$Modal.error({title: '错误', content: e.message});
            });
        }
    }
</script>
